webpackJsonp([138007624281660],{

/***/ 48:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AuthorThumbnail = function (_React$Component) {
	  _inherits(AuthorThumbnail, _React$Component);
	
	  function AuthorThumbnail() {
	    _classCallCheck(this, AuthorThumbnail);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  AuthorThumbnail.prototype.render = function render() {
	    var _props = this.props,
	        avatar = _props.avatar,
	        name = _props.name;
	
	    if (avatar && name) {
	      return _react2.default.createElement("img", {
	        className: "author-thumb",
	        src: avatar,
	        alt: name,
	        "data-pin-nopin": "true"
	      });
	    }
	    return null;
	  };
	
	  return AuthorThumbnail;
	}(_react2.default.Component);
	
	exports.default = AuthorThumbnail;
	module.exports = exports["default"];

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _AuthorThumbnail = __webpack_require__(35);
	
	var _AuthorThumbnail2 = _interopRequireDefault(_AuthorThumbnail);
	
	var _PostTags = __webpack_require__(64);
	
	var _PostTags2 = _interopRequireDefault(_PostTags);
	
	var _SiteConfig = __webpack_require__(11);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _AuthorLink = __webpack_require__(58);
	
	var _AuthorLink2 = _interopRequireDefault(_AuthorLink);
	
	var _PostFormatting = __webpack_require__(39);
	
	var _PostFormatting2 = _interopRequireDefault(_PostFormatting);
	
	var _PostHeader = __webpack_require__(69);
	
	var _PostHeader2 = _interopRequireDefault(_PostHeader);
	
	var _PostDate = __webpack_require__(63);
	
	var _PostDate2 = _interopRequireDefault(_PostDate);
	
	var _authorModel = __webpack_require__(40);
	
	var _authorModel2 = _interopRequireDefault(_authorModel);
	
	__webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPostList = function getPostList(postEdges, authorEdges, thumbnails) {
	  return postEdges.map(function (postEdge) {
	    return {
	      path: postEdge.node.fields.path,
	      tags: postEdge.node.frontmatter.tags,
	      // cover: postEdge.node.frontmatter.cover,
	      cover: thumbnails ? thumbnails[postEdge.node.fields.slug.slice(1) + "-thumbnail"] : postEdge.node.frontmatter.cover,
	      title: postEdge.node.frontmatter.title,
	      date: postEdge.node.frontmatter.date,
	      synopsis: postEdge.node.frontmatter.synopsis,
	      // author: AuthorModel.getAuthor(
	      //   authorEdges,
	      //   postEdge.node.frontmatter.author,
	      //   SiteConfig.blogAuthorId
	      // ),
	      excerpt: postEdge.node.excerpt,
	      timeToRead: postEdge.node.timeToRead
	    };
	  });
	};
	
	var PostListing = function (_React$Component) {
	  _inherits(PostListing, _React$Component);
	
	  function PostListing() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PostListing);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.defaultProps = {
	      postAuthors: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PostListing.prototype.render = function render() {
	    var filmList = [];
	    // console.log(this.props.postEdges);
	    var postList = getPostList(this.props.postEdges, this.props.postAuthors, this.props.thumbnails);
	    console.log("post list", postList);
	    var limit = this.props.limit ? this.props.limit : postList.length;
	    for (var i = 0; i < limit; i++) {
	      var post = postList[i];
	      if (post) {
	        var title = post.title,
	            path = post.path,
	            excerpt = post.excerpt,
	            author = post.author,
	            tags = post.tags,
	            date = post.date,
	            cover = post.cover,
	            synopsis = post.synopsis;
	
	        console.log("cover", cover);
	        // TODO: refactor this synopsis section
	        var displaySynopsis = synopsis;
	        if (synopsis) {
	          var trimmedSynopsis = synopsis.slice(0, this.MAX_SYNOPSIS_LENGTH);
	          trimmedSynopsis = trimmedSynopsis.slice(0, Math.min(trimmedSynopsis.length, trimmedSynopsis.lastIndexOf(" "))) + "...";
	          displaySynopsis = synopsis.length > 25 && trimmedSynopsis ? trimmedSynopsis : synopsis;
	        }
	
	        var className = post.post_class ? post.post_class : "film-thumbnail-background";
	        var style = {
	          backgroundImage: "linear-gradient(\n            to left, rgba(255, 255, 255, 0) 0%,\n            rgba(255, 255, 255, 0.83) 75%,\n            rgb(255, 255, 255) 100%),\n          url(" + cover + ")"
	        };
	        filmList.push(_react2.default.createElement(
	          _PostFormatting2.default,
	          {
	            className: className,
	            key: title,
	            style: style,
	            path: path
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "film-listing-text" },
	            _react2.default.createElement(
	              "h2",
	              { className: "film-list-title" },
	              title
	            ),
	            _react2.default.createElement(
	              "section",
	              { className: "post-excerpt" },
	              _react2.default.createElement(
	                "p",
	                null,
	                displaySynopsis,
	                " \xBB"
	              )
	            )
	          )
	        ));
	      }
	    }
	    return _react2.default.createElement(
	      "div",
	      null,
	      filmList,
	      limit < postList.length && _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/films", className: "no-dec" },
	        _react2.default.createElement(
	          "button",
	          { className: "show-more-button" },
	          _react2.default.createElement(
	            "span",
	            { style: { verticalAlign: "middle" } },
	            "See more "
	          ),
	          _react2.default.createElement(
	            "span",
	            { style: { fontSize: 24, verticalAlign: "middle" } },
	            "\u279C"
	          )
	        )
	      )
	    );
	  };
	
	  return PostListing;
	}(_react2.default.Component);
	
	exports.default = PostListing;
	module.exports = exports["default"];

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainContent = function (_React$Component) {
	  _inherits(MainContent, _React$Component);
	
	  function MainContent() {
	    _classCallCheck(this, MainContent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MainContent.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    var classes = (0, _classnames2.default)("content", this.props.className);
	
	    return _react2.default.createElement(
	      "main",
	      { id: "content", className: classes, role: "main" },
	      children
	    );
	  };
	
	  return MainContent;
	}(_react2.default.Component);
	
	exports.default = MainContent;
	module.exports = exports["default"];

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostFormatting = function (_React$Component) {
	  _inherits(PostFormatting, _React$Component);
	
	  function PostFormatting() {
	    _classCallCheck(this, PostFormatting);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PostFormatting.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        style = _props.style,
	        path = _props.path;
	
	    console.log("true path", path);
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: path, className: "no-dec" },
	      _react2.default.createElement(
	        "article",
	        { className: className, style: style },
	        children
	      )
	    );
	  };
	
	  return PostFormatting;
	}(_react2.default.Component);
	
	exports.default = PostFormatting;
	module.exports = exports["default"];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PostListing = __webpack_require__(38);
	
	var _PostListing2 = _interopRequireDefault(_PostListing);
	
	var _SiteConfig = __webpack_require__(11);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Drawer = __webpack_require__(66);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _SEO = __webpack_require__(65);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Navigation = __webpack_require__(62);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _SiteWrapper = __webpack_require__(70);
	
	var _SiteWrapper2 = _interopRequireDefault(_SiteWrapper);
	
	var _MainContent = __webpack_require__(94);
	
	var _MainContent2 = _interopRequireDefault(_MainContent);
	
	var _MainHeader = __webpack_require__(67);
	
	var _MainHeader2 = _interopRequireDefault(_MainHeader);
	
	var _MainNav = __webpack_require__(68);
	
	var _MainNav2 = _interopRequireDefault(_MainNav);
	
	var _BlogLogo = __webpack_require__(59);
	
	var _BlogLogo2 = _interopRequireDefault(_BlogLogo);
	
	var _MenuButton = __webpack_require__(61);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _Footer = __webpack_require__(60);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _MenuTemplate2 = __webpack_require__(71);
	
	var _MenuTemplate3 = _interopRequireDefault(_MenuTemplate2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilmPage = function (_MenuTemplate) {
	  _inherits(FilmPage, _MenuTemplate);
	
	  function FilmPage() {
	    _classCallCheck(this, FilmPage);
	
	    return _possibleConstructorReturn(this, _MenuTemplate.apply(this, arguments));
	  }
	
	  FilmPage.prototype.render = function render() {
	    var postEdges = this.props.data.allMarkdownRemark && this.props.data.allMarkdownRemark.edges ? this.props.data.allMarkdownRemark.edges : [];
	
	    var thumbnails = {};
	    if (this.props.data.filmPics) {
	      this.props.data.filmPics.edges.forEach(function (edge) {
	        return thumbnails[edge.node.name] = edge.node.childImageSharp.resize.src;
	      });
	    }
	    console.log("pedges", postEdges);
	    return _react2.default.createElement(
	      _Drawer2.default,
	      { className: "post-template", isOpen: this.state.menuOpen },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Films by | " + _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_Navigation2.default, { config: _SiteConfig2.default, onClose: this.handleOnClose }),
	      _react2.default.createElement(
	        _SiteWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _MainHeader2.default,
	          { className: "post-head", color: "white" },
	          _react2.default.createElement(
	            _MainNav2.default,
	            null,
	            _react2.default.createElement(_BlogLogo2.default, { logo: _SiteConfig2.default.siteLogo, title: _SiteConfig2.default.siteTitle }),
	            _react2.default.createElement(_MenuButton2.default, {
	              navigation: _SiteConfig2.default.siteNavigation,
	              onClick: this.handleOnClick
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _MainContent2.default,
	          null,
	          _react2.default.createElement(
	            "h1",
	            { className: "text-center" },
	            "Our Films"
	          ),
	          _react2.default.createElement(_PostListing2.default, { postEdges: postEdges, thumbnails: thumbnails })
	        ),
	        _react2.default.createElement(_Footer2.default, {
	          copyright: _SiteConfig2.default.copyright,
	          promoteGatsby: _SiteConfig2.default.promoteGatsby
	        })
	      )
	    );
	  };
	
	  return FilmPage;
	}(_MenuTemplate3.default);
	
	exports.default = FilmPage;
	
	/* eslint no-undef: "off" */
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-films-jsx-4a09426d16ad217ca0cb.js